import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Row, Col } from "react-flexbox-grid";
import GroupingSelect from "../forms/grouping-select";
import PropTypes from 'prop-types';
import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { useApollo } from "apollo";

const GET_ALL_TYPING = gql`
  query($indicator: ID!){
    availableTyping(indicator:$indicator)
  }
`;

const styles = theme => ({
  container: {
    marginTop: theme.spacing.unit,
  }
});

const TypingFilter = ({
    classes,
    value,
    label,
    handleChange, 
    helperText,
    placeholder,
    disabled,
    indicator
  }) => {
  const { application : client} = useApollo();
  const {data} = useQuery(GET_ALL_TYPING, {
    variables : {indicator : indicator ? indicator : ''},
    client,
  });

  const zoneOptions = [
      { value: 'URBAN', label: 'Urbana' },
      { value: 'RURAL', label: 'Rural' },
  ];

  const sexOptions = [
      { value: 'MEN',   label: 'Hombres' },
      { value: 'WOMEN', label: 'Mujeres' },
  ];

  const totalOptions = [
      { value: 'TOTAL', label: 'Total' },
  ]

  const groupedOptions = [
      {
          label: 'Zona',
          options: zoneOptions,
      },
      {
          label: 'Sexo',
          options: sexOptions,
      },
      {
          label: 'Total',
          options: totalOptions, 
      }
  ];

  const getData = (data=[]) => {
    let zoneOptions= [];
    let sexOptions= [];
    let totalOptions= [];

    data.forEach(item => {
        switch(item){
          case 'TOTAL' :
            totalOptions.push({value : item, label : 'Total'});
            break;
          case 'WOMEN' :
            sexOptions.push({value : item, label : 'Mujeres'});
            break;
          case 'MEN' :
            sexOptions.push({value : item, label : 'Hombres'});
            break;
          case 'RURAL' :
            zoneOptions.push({value : item, label : 'Rural'});
            break;
          case 'URBAN' :
            zoneOptions.push({value : item, label : 'Urbana'});
            break;
          default :
            break;
        }
    });

    return [
      {
          label: 'Zona',
          options: zoneOptions,
      },
      {
          label: 'Sexo',
          options: sexOptions,
      },
      {
          label: 'Total',
          options: totalOptions, 
      }
   ];

  }

  const types = data && data.availableTyping ? data.availableTyping : []
  return (
    <Row className={classes.container}>
      <Col xs={12}>
        <GroupingSelect
          value={value}
          onChange={event => {
            handleChange("typing", event.value);
          }}
          name="typing"
          data={!indicator ? groupedOptions : getData(types)}
          helperText={helperText ? helperText : ""}
          label={label}
          placeholder={placeholder}
          disabled={disabled}
        />
      </Col>
    </Row>
  );
};

TypingFilter.propTypes = {
  classes      : PropTypes.object, 
  value        : PropTypes.string, 
  handleChange : PropTypes.func, 
  helperText   : PropTypes.string,
  label        : PropTypes.string,
  placeholder  : PropTypes.string,
  disabled     : PropTypes.bool,
}

export default withStyles(styles)(TypingFilter);



// WEBPACK FOOTER //
// ./src/components/filters/typingFilter.js